import {
  type ImageUploadPreset,
  compressImageForUpload,
} from "@/features/media/utils/compressImageForUpload";
import { validateImageFile } from "@/features/media/utils/validateImageFile";

export class ImageSelectionError extends Error {
  readonly fileSize: number;

  constructor(message: string, fileSize: number) {
    super(message);
    this.name = "ImageSelectionError";
    this.fileSize = fileSize;
  }
}

export async function selectImageFileForUpload(
  file: File,
  preset: ImageUploadPreset,
): Promise<File> {
  const errorMessage = validateImageFile(file);
  if (errorMessage) {
    throw new ImageSelectionError(errorMessage, file.size);
  }

  try {
    return await compressImageForUpload(file, preset);
  } catch {
    return file;
  }
}
